module.exports = __webpack_public_path__ + "img/slider-beni-box.16281e89.png";